// 6 favicon SVG options as inline strings — gold (#c9a84c) on navy (#1a2e5a)
// Sized for 96x96 preview. Uses simple, recognizable shapes.

const wrap = (inner) =>
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 96 96'>
    <defs>
      <linearGradient id='bg' x1='0' y1='0' x2='1' y2='1'>
        <stop offset='0%' stop-color='#1a2e5a'/>
        <stop offset='100%' stop-color='#0a1530'/>
      </linearGradient>
    </defs>
    <rect width='96' height='96' rx='22' fill='url(#bg)'/>
    ${inner}
  </svg>`;

export const FAVICONS = [
  {
    id: 1,
    name: "AK Monogram",
    desc: "Serif AK letters interlocked — refined, signature feel.",
    svg: wrap(`
      <text x='30' y='66' font-family='Georgia, serif' font-weight='700' font-size='52' fill='#c9a84c'>A</text>
      <text x='52' y='66' font-family='Georgia, serif' font-weight='700' font-size='52' fill='#c9a84c' opacity='0.55'>K</text>
      <line x1='18' y1='78' x2='78' y2='78' stroke='#c9a84c' stroke-width='1.5' opacity='0.6'/>
    `),
  },
  {
    id: 2,
    name: "Steaming Pot",
    desc: "Karahi with rising steam — instantly says 'home cooking'.",
    svg: wrap(`
      <g fill='none' stroke='#c9a84c' stroke-width='2.4' stroke-linecap='round'>
        <path d='M28 38 Q33 26 38 38 M44 38 Q49 26 54 38 M60 38 Q65 26 70 38'/>
      </g>
      <path d='M22 50 L74 50 Q74 70 60 76 L36 76 Q22 70 22 50 Z' fill='#c9a84c'/>
      <rect x='14' y='48' width='14' height='4' rx='2' fill='#c9a84c'/>
      <rect x='68' y='48' width='14' height='4' rx='2' fill='#c9a84c'/>
      <ellipse cx='48' cy='51' rx='26' ry='4' fill='#0a1530' opacity='0.45'/>
    `),
  },
  {
    id: 3,
    name: "Lotus + A",
    desc: "Stylised lotus petals around a serif 'A' — Indian heritage.",
    svg: wrap(`
      <g fill='none' stroke='#c9a84c' stroke-width='2' stroke-linecap='round'>
        <path d='M48 18 Q60 32 48 50 Q36 32 48 18 Z'/>
        <path d='M48 18 Q66 30 60 50 Q44 38 48 18 Z' opacity='0.7'/>
        <path d='M48 18 Q30 30 36 50 Q52 38 48 18 Z' opacity='0.7'/>
      </g>
      <text x='48' y='80' text-anchor='middle' font-family='Georgia, serif' font-weight='700' font-size='32' fill='#c9a84c'>A</text>
    `),
  },
  {
    id: 4,
    name: "Tiffin Dabba",
    desc: "Stacked tiffin tins — literal & charming for tiffin service.",
    svg: wrap(`
      <g fill='none' stroke='#c9a84c' stroke-width='2.5' stroke-linecap='round'>
        <ellipse cx='48' cy='30' rx='22' ry='5'/>
        <path d='M26 30 L26 46 Q26 50 48 50 Q70 50 70 46 L70 30'/>
        <path d='M28 50 L28 64 Q28 68 48 68 Q68 68 68 64 L68 50'/>
        <path d='M30 68 L30 80 Q30 82 48 82 Q66 82 66 80 L66 68'/>
        <line x1='44' y1='14' x2='52' y2='14' stroke-width='3'/>
        <path d='M44 14 Q48 6 52 14' stroke-width='2'/>
      </g>
    `),
  },
  {
    id: 5,
    name: "Peepal Leaf + A",
    desc: "Sacred leaf with embedded A — organic, earthy heritage.",
    svg: wrap(`
      <path d='M48 18 Q72 36 70 60 Q60 78 48 80 Q36 78 26 60 Q24 36 48 18 Z'
        fill='none' stroke='#c9a84c' stroke-width='2.4'/>
      <path d='M48 22 L48 80' stroke='#c9a84c' stroke-width='1.5' opacity='0.5'/>
      <text x='48' y='62' text-anchor='middle' font-family='Georgia, serif' font-weight='700' font-size='28' fill='#c9a84c'>A</text>
    `),
  },
  {
    id: 6,
    name: "Roti + Spoon",
    desc: "A roti circle with a spoon — humble, food-forward.",
    svg: wrap(`
      <circle cx='42' cy='52' r='24' fill='none' stroke='#c9a84c' stroke-width='2.5'/>
      <circle cx='42' cy='52' r='24' fill='#c9a84c' opacity='0.18'/>
      <circle cx='36' cy='46' r='1.5' fill='#c9a84c'/>
      <circle cx='48' cy='42' r='1.2' fill='#c9a84c'/>
      <circle cx='52' cy='58' r='1.4' fill='#c9a84c'/>
      <circle cx='38' cy='60' r='1.2' fill='#c9a84c'/>
      <ellipse cx='72' cy='32' rx='7' ry='10' fill='none' stroke='#c9a84c' stroke-width='2.4' transform='rotate(35 72 32)'/>
      <line x1='76' y1='40' x2='84' y2='62' stroke='#c9a84c' stroke-width='2.4' stroke-linecap='round'/>
    `),
  },
];

// Current favicon for reference
export const CURRENT_FAVICON_SVG = wrap(`
  <circle cx='48' cy='48' r='34' fill='none' stroke='#c9a84c' stroke-width='2.4'/>
  <text x='48' y='66' text-anchor='middle' font-family='Georgia, serif' font-weight='700' font-size='46' fill='#c9a84c'>A</text>
`);
